export enum AnalyticsScreen {
  DeviceDrawer = 'DeviceDrawer',
  ActiveIncidentDrawer = 'ActiveIncidentDrawer',
  DeviceHoverModal = 'DeviceHoverModal',
}

export enum PlayerEvents {
  backward10 = 'ButtonPress:Backward10',
  forward10 = 'ButtonPress:Forward10',
  play = 'ButtonPress:Play',
  pause = 'ButtonPress:Pause',
  fullscreen = 'ButtonPress:Fullscreen',
  toggleLiveFeed = 'ButtonPress:ToggleLiveFeed',
  toggleIncidentClip = 'ButtonPress:ToggleIncidentClip',
  toggleExtendedClip = 'ButtonPress:ToggleExtendedClip',
  requestLiveFeed = 'RequestLiveFeed',
  receivedLiveFeed = 'ReceivedLiveFeed',
  playLiveFeed = 'PlayLiveFeed',
  requestIncidentClip = 'RequestIncidentClip',
  receivedIncidentClip = 'ReceivedIncidentClip',
  playIncidentClip = 'PlayIncidentClip',
  liveStreamLatency = 'LiveStreamLatency',
  // The <video> element raised an error after the URL was set
  videoPlaybackError = 'VideoPlaybackError',
  // The URL was set but playback took a while to start
  videoPlaybackStalled = 'VideoPlaybackStalled',
}

export enum ClipLoaderEvents {
  shown = 'ClipLoader Shown',
  timedOut = 'ClipLoader TimedOut',
  viewedLive = 'ClipLoader ViewedLive',
  clipAvailableCollapsed = 'ClipLoader ClipAvailable Collapsed',
  clipAvailableLive = 'ClipLoader ClipAvailable Live',
  clipClicked = 'ClipLoader ClipClicked',
  showedBlurredPreview = 'ClipLoader - Blurred Preview Shown',
}

export type MixpanelEvents = PlayerEvents | ClipLoaderEvents
